<template>
  <div>
    Cloud Recordings
    <span class="sim-hover primary--text" @click="openCameraDialog(getExid)">
      {{ getName }}
    </span>
    updated.
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    getExid() {
      return this.item.details?.exid || this.item.details?.camera?.exid
    },
    getName() {
      return this.item.details?.name || this.item.details?.camera?.name
    },
  },
  methods: {
    openCameraDialog(cameraId) {
      this.$emit("open-camera-dialog", cameraId)
    },
  },
}
</script>
